import React from 'react';
import {BarChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Box from 'grommet/components/Box';

const names = ["Label 1", "Label 2", "Label 3"]

class BarSample extends React.Component {
    constructor() {
        super();
    }
    
    render() {
        let dataObject = [];
        if (this.props.dataObject[0]) {
            dataObject = this.props.dataObject[0].map((input, index)=>{
                const newDate = input.date;
                const firstPart = newDate.substr(10,5)
                const secondPart = newDate.substr(0,10)
                const finalString = `${secondPart} ${firstPart}`
                return {
                    date: finalString,
                    values: input.values
                }
            })
        }      
        return (
            <div>
            <h2>Title</h2>
                <BarChart
                    data={dataObject}
                    names={names}
                    rotate={this.props.optionsObject.rotate}
                    stack={(this.props.optionsObject.stack) ? 'regular' : 'none'}
                    xtitle={'Title X'}
                    ytitle={'Title Y'}
                    legends={this.props.optionsObject.legends}
                ></BarChart>
            </div>  
        );
    }
}

export default BarSample;



// WEBPACK FOOTER //
// ./src/samples/run/bar.js